module.exports = __webpack_public_path__ + "img/756.bde02115.gif";